module.exports = __webpack_public_path__ + "img/public.38a3fdcc.png";